import React from 'react';
import { motion } from 'framer-motion';
import { FiMessageCircle, FiCode, FiSend, FiTrendingUp } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const steps = [
  { num: '01', icon: FiMessageCircle, title: 'Consultation', desc: 'Understanding your business goals and current bottlenecks.' },
  { num: '02', icon: FiCode, title: 'Build', desc: 'Crafting custom websites and automated systems tailored to you.' },
  { num: '03', icon: FiSend, title: 'Launch', desc: 'Deploying your new digital systems seamlessly into the wild.' },
  { num: '04', icon: FiTrendingUp, title: 'Grow', desc: 'Driving leads and scaling your business with continuous support.' }
];

const HowWeWork = () => {
  return (
    <section id="process" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-base text-emerald-600 font-semibold tracking-wide uppercase">Our Process</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">How We Work</p>
        </div>

        <div className="relative">
          {/* Connecting Line for Desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-slate-100 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 relative z-10">
            {steps.map((step, index) => (
              <motion.div 
                key={step.title} 
                initial={{ opacity: 0, y: 20 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ delay: index * 0.15, duration: 0.5 }} 
                className="relative bg-white pt-8 px-6 pb-8 rounded-3xl border border-slate-100 shadow-sm hover:shadow-lg transition-all text-center flex flex-col items-center"
              >
                <div className="w-20 h-20 bg-white border-4 border-slate-50 rounded-full flex items-center justify-center text-emerald-600 mb-6 shadow-sm absolute -top-10 lg:-top-10">
                  <SafeIcon icon={step.icon} className="text-2xl" />
                </div>
                <div className="text-emerald-100 font-black text-5xl absolute top-4 right-4 opacity-50 select-none">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 mt-6">{step.title}</h3>
                <p className="text-slate-500 leading-relaxed text-sm">{step.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
